<template>
  <el-container class="CategoryForm">
    <el-main class="p-0">
      <el-form :model="data" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="상위 분류" prop="parent_id">
          <el-col :span="24">
            <AProductTypeSelector
              v-model="data.parent_id"
              limitSecondLevel
            />
          </el-col>
        </el-form-item>
        <el-form-item label="이름" prop="name">
          <el-col :span="24">
            <el-input v-model="data.name" maxlength="50" />
          </el-col>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer height="40px">
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
      >{{$t('button.save')}} (F4)</el-button>
      <el-button type="danger" v-if="!isNew" :disabled="!has_grant_write" @click="clickDel">삭 제</el-button>
      <el-button class="close-button" @click="closeDialog">{{$t('button.close')}}(Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import { form } from "@/common/mixins/form";

export default {
  name: "CategoryForm",
  mixins: [form],
  data() {
    let validateName = (rule, value, callback) => {
      if (value.trim().length < 1) {
        callback(new Error("이름을 입력하세요."));
      } else {
        callback();
      }
    };
    return {
      title: '품목구분관리',
      rules: {
        name: [
          { required: true, message: "이름을 입력하세요." },
          { validator: validateName }
        ],
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          parent_id: null,
          name: '',
        }
      }
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_product_type"]),
    isNew: function() {
      return this.data.id < 1;
    },
    options: function() {      
      return this.table_product_type;
    },
  },
  methods: {
    doRegister() {
      if (this.isNew) {
        this.api.createProductType(this.data).then(res => {
          this.handleResult(res, this.$t('message.success_create'));
        });
      } else {
        this.api.updateProductType(this.data).then(res => {
          this.handleResult(res, this.$t('message.success_update'));
        });
      }
    },
    doDelete() {
      this.api.deleteProductType(this.data).then(res => {
        this.handleResult(res, this.$t('message.success_delete'));
      });
    },
    clickDel() {
      this.util.confirm_delete(
        this,
        "품목분류[" + this.data.name + "]",
        this.doDelete
      );
    },
    handleResult(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.$emit("completed", this.util.get_notify_options("s", "품목분류", message));
    },
    handleClickRegister() {
      if( !this.has_grant_write ) return;

      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.doRegister();
      });
    },
  },
};
</script>
